import React from 'react';
import { Wallet, ShieldCheck, Globe2 } from 'lucide-react';
import { polygonIdentityConfig } from '../config/tldIdentity';

const TldIdentity = () => (
  <section id="identity" className="py-24 lg:py-32 border-t border-border bg-muted/20">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <div>
        <div className="section-label mb-4">Web Domain + Polygon Identity Layer</div>
        <h2 className="font-display text-4xl lg:text-5xl font-bold leading-[1.1] tracking-tight text-foreground">
          <span className="gradient-text">{polygonIdentityConfig.webDomain}</span> for web. {polygonIdentityConfig.namespace} for Web3 identity.
        </h2>
        <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
          Tangibl3Net separates the public website from the on-chain namespace. {polygonIdentityConfig.webDomain} is the conventional web domain for users and issuers. The {polygonIdentityConfig.namespace} Web3 TLD on Polygon can connect issuer workspaces, wallets, certificate programs, and public verification records.
        </p>
        <p className="mt-4 text-lg text-muted-foreground leading-relaxed">
          The Web3 name is an identity pointer and registry object, not the legal instrument itself.
        </p>
        <div className="mt-6 rounded-xl border border-border bg-card p-4 text-sm text-muted-foreground leading-relaxed">
          {polygonIdentityConfig.disclaimer}
        </div>
      </div>

      <div className="rounded-2xl border border-border bg-card p-6 lg:p-8 shadow-xl shadow-slate-900/5">
        <div className="mb-6 grid gap-3">
          <div className="rounded-xl border border-border bg-background p-4">
            <div className="text-xs uppercase tracking-wider text-muted-foreground mb-1">Conventional web domain</div>
            <div className="font-mono text-lg font-bold text-foreground">{polygonIdentityConfig.webDomain}</div>
          </div>
          <div className="rounded-xl border border-border bg-background p-4">
            <div className="text-xs uppercase tracking-wider text-muted-foreground mb-1">Polygon Web3 TLD</div>
            <div className="font-mono text-lg font-bold text-foreground">{polygonIdentityConfig.namespace}</div>
          </div>
        </div>

        <div className="grid gap-4 mb-6">
          {polygonIdentityConfig.examples.map((example) => (
            <div key={example} className="flex items-center justify-between rounded-xl border border-border bg-background p-4">
              <div className="flex items-center gap-3">
                <Globe2 className="w-5 h-5 text-primary" />
                <span className="font-mono text-sm text-foreground">{example}</span>
              </div>
              <span className="rounded-md bg-muted px-2.5 py-1 font-mono text-[11px] text-muted-foreground">example</span>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-3 mb-6">
          {polygonIdentityConfig.identityStates.map((state) => (
            <div key={state} className="rounded-lg border border-border bg-muted/30 p-3 text-center font-mono text-xs text-foreground">
              {state}
            </div>
          ))}
        </div>
        <div className="grid md:grid-cols-2 gap-3">
          <div className="rounded-xl border border-border bg-background p-4">
            <Wallet className="w-5 h-5 text-primary mb-3" />
            <div className="font-semibold text-foreground">Wallet connection</div>
            <div className="text-xs text-muted-foreground mt-1">Safe stub until environment variables and contracts are configured.</div>
          </div>
          <div className="rounded-xl border border-border bg-background p-4">
            <ShieldCheck className="w-5 h-5 text-primary mb-3" />
            <div className="font-semibold text-foreground">Chain policy</div>
            <div className="text-xs text-muted-foreground mt-1">{polygonIdentityConfig.chain.mainnetName} first, {polygonIdentityConfig.chain.testnetName} for testing.</div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default TldIdentity;
